import { chain } from '@leprecoins/effector';
import { sample } from 'effector';
import { debounce } from 'patronum';
import { accountTreeModel } from 'entities/account';
import { createAccountTransactionRegistryModel } from 'entities/transaction';

export const accountTransactionRegistryModel = createAccountTransactionRegistryModel({});

sample({
	clock: debounce(accountTreeModel.$selectedNodes, 300),
	target: accountTransactionRegistryModel.registryModel.filters.accountIds.setValue,
});

chain(
	accountTransactionRegistryModel.registryModel.clearFilters,
	accountTreeModel.clearSelectedNodes,
);

export const accountsTransactionPageModel = { accountTransactionRegistryModel };
